(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.DownloadController = (function(superClass) {
    extend(DownloadController, superClass);

    function DownloadController(scope, transitions, repo) {
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.loadRemainingDuplicates = bind(this.loadRemainingDuplicates, this);
      this.next = bind(this.next, this);
      this.previous = bind(this.previous, this);
      DownloadController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.step.title = 'Download';
      this.scope.step.next = this.next;
      this.scope.step.previous = this.previous;
      this.scope.placeholder = 'Loading duplicate fields...';
      this.scope.remaining_duplicates = [];
      this.loadRemainingDuplicates();
    }

    DownloadController.prototype.previous = function() {
      return this.scope.goToStep('farm_field');
    };

    DownloadController.prototype.next = function() {
      return this.repo.launchPsr(this.scope.selected, this.scope.step);
    };

    DownloadController.prototype.loadRemainingDuplicates = function() {
      var arr, copy, field, i, len, ref, ref1, year;
      this.scope.remaining_duplicates = [];
      ref = this.scope.selected.duplicate_fields;
      for (i = 0, len = ref.length; i < len; i++) {
        field = ref[i];
        copy = $.extend(true, {}, field);
        ref1 = copy.survey_results;
        for (year in ref1) {
          arr = ref1[year];
          if (arr.length === 1) {
            delete copy.survey_results[year];
          }
        }
        if (Object.keys(copy.survey_results).length > 0) {
          this.scope.remaining_duplicates.push(copy);
        }
      }
      return this.scope.placeholder = 'No duplicate fields to display';
    };

    return DownloadController;

  })(Controller);

}).call(this);
